import React, { useEffect } from "react";
import "../styles/Signup.css";
import { X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import sideIcon from "../assets/images/side6.png";

const Signup = ({ onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { text: "Sign up to business", path: "https://place.berymo.com/#/signup", external: true },
    { text: "Sign up to ride", path: "https://onelink.to/5mae6v", external: true },
    { text: "Sign up to drive", path: "https://onelink.to/rtv72g", external: true },
  ];

  useEffect(() => {
    if (location.pathname.startsWith("/signup/")) {
      onClose();
    }
  }, [location.pathname, onClose]);

  const handleClick = (item, event) => {
    event.preventDefault();
    if (item.external) {
      window.location.href = item.path;
    } else {
      navigate(item.path);
    }
    onClose();
  };

  return (
    <>
      <style>{`
        body.signup-open {
          overflow: hidden;
          position: fixed;
          width: 100%;
          height: 100%;
          top: 0;
        }

        .signup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0);
          display: flex;
          justify-content: flex-end;
          z-index: 9999;
          animation: fadeIn 0.3s ease-out forwards;
        }

        .signup-panel {
          background: white;
          width: 450px;
          height: 100%;
          padding: 90px 24px 24px 64px;
          margin: 0;
          display: flex;
          flex-direction: column;
          box-shadow: -4px 0 20px rgba(0, 0, 0, 0.2);
          overflow-y: auto;
          box-sizing: border-box;
          clip-path: polygon(55px 0, 100% 0, 100% 100%, 0 100%);
          transform: translateX(100%);
          animation: slideIn 0.3s ease-out forwards;
          scroll-behavior: smooth;
        }

        @keyframes fadeIn {
          from {
            background-color: rgba(0, 0, 0, 0);
          }
          to {
            background-color: rgba(0, 0, 0, 0.5);
          }
        }

        @keyframes slideIn {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }

        .signup-close {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 50px;
        }

        .signup-close button {
          background: none;
          border: none;
          cursor: pointer;
        }

        .signup-close button svg {
          width: 25px;
          height: 25px;
          color: #000;
          margin-right: 25px;
          stroke-width: 2.5;
        }

        .signup-list {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .signup-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 24px;
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .signup-item a {
          text-decoration: none !important;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #000;
          font-weight: bold;
          font-size: 18px;
          width: 100%;
        }

        .signup-item:hover a {
          color: #fd5c63;
        }

        .signup-item img.menu-arrow {
          width: 20px;
          height: 20px;
          transition: filter 0.3s ease;
        }

        .signup-item:hover img.menu-arrow {
          filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(320deg);
        }

        /* === MOBILE STYLES === */
@media (max-width: 768px) {
  .signup-overlay {
    position: fixed;
    top: 50px; /* Below navbar */
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    display: flex;
   
    justify-content: center;
    align-items: flex-start;
    animation: fadeInMobile 0.3s ease-out forwards;
  }

  .signup-overlay.closing {
    animation: fadeOutMobile 0.3s ease-out forwards;
   
  }

.signup-panel {
  width: 100%;
  height: calc(100% - 60px);
  overflow-y: auto;
  clip-path: none;
  box-shadow: none;
  padding: 25px;
  transform: translateY(-100%);
  animation: slideInFromTop 0.3s ease-out forwards;
  scroll-behavior: smooth;

  font-size: 14px;
  font-weight: 400;
  color: #000;
}

  /* 👉 Animate when closing: scroll up */
  .signup-overlay.closing .signup-panel {
    animation: slideOutToBottom 0.3s ease-out forwards;
  }

  @keyframes fadeInMobile {
    from {
      background-color: rgba(255, 255, 255, 0);
    }
    to {
      background-color: #fff;
    }
  }

  @keyframes fadeOutMobile {
    from {
      background-color: #fff;
    }
    to {
      background-color: rgba(255, 255, 255, 0);
    }
  }

  @keyframes slideInFromTop {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  /* 🔁 New animation: scroll bottom-to-top when closing */
  @keyframes slideOutToBottom {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-100%);
    }
  }

  .signup-close {
    display: none;
  }

  .signup-list {
    list-style: none;
    padding: 0 10px;
    margin: 0;
    display: flex;
    flex-direction: column;
  }

  .signup-item {
    padding: 18px 0;
    border-bottom: 0.5px solid #e2e2e2;
    
  }

 .signup-item a {
    font-size: 14px; 
    text-decoration: none !important;
    color: #000;
    font-weight: 500;
    font-family: 'HelveticaNeue-Bold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
   
  }
  

  .signup-item:hover a {
    color: #fd5c63;
  }

  .signup-item img.menu-arrow {
    width: 14px;
    height: 14px;
  }

  .signup-item:last-child {
    border-bottom: none;
  }
}
        
      `}</style>

      <div className="signup-overlay signup-show">
        <div className="signup-panel">
          <div className="signup-close">
            <button onClick={onClose} aria-label="Close">
              <X size={24} />
            </button>
          </div>

          <div className="signup-list">
            {items.map((item, index) => (
              <div
                key={index}
                className="signup-item"
                onClick={(event) => handleClick(item, event)}
              >
                <a href={item.path} onClick={(e) => e.preventDefault()}>
                  <span>{item.text}</span>
                  <img src={sideIcon} alt="arrow" className="menu-arrow" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;